import { useState } from "react";
import { Flag } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import SupportRequestForm from "@/components/SupportRequestForm";

interface Props {
  reviewId: string;
  reviewTitle?: string;
}

const ReportReviewDialog = ({ reviewId, reviewTitle }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          className="ml-auto flex items-center gap-1 text-xs text-muted-foreground hover:text-destructive transition-colors"
          aria-label="Report this review"
        >
          <Flag className="w-3.5 h-3.5" />
          Report
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Report this review</DialogTitle>
          <DialogDescription>
            Flag content that violates our community guidelines. Our team reviews every report.
          </DialogDescription>
        </DialogHeader>
        <SupportRequestForm
          requestType="review_report"
          reviewId={reviewId}
          defaultSubject={reviewTitle ? `Report: ${reviewTitle}` : `Report: review ${reviewId}`}
          submitLabel="Submit report"
          onSubmitted={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ReportReviewDialog;
